import { WizardStep } from "../../../wizard/wizard.component";
import { Component, OnInit, ViewChild, ElementRef, Input } from "@angular/core";
import { FilterService } from "../../../services/filter.service";
import { ReservationWizardService } from "../../../services/wizard/reservation/reservation.wizard.service";
import { EquipmentService } from "../../../services/equipment.service";
import { FilterCompleteService } from "src/app/filter-complete/filter-complete";
import { EquipmentFilter } from "src/app/model/equipment-filter";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ValidateAutoCompleteSelect } from "src/app/validators/autocomplete-select.validator";
import { PhysicianFilter } from "../../../model/physician-Filter";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { ReservationSlot } from "src/app/model/reservation-slot";
import { ReservationExtraordinaryCalendar } from "../../../model/reservation";
import { AuthService } from "../../../services/auth.service";
@Component({
  selector: "app-reservation-extraordinary-calendar",
  templateUrl: "./reservation-extraordinary-calendar.component.html",
  styleUrls: ["./reservation-extraordinary-calendar.component.css"],
})
export class ReservationExtraordinaryCalendarComponent
  implements OnInit, WizardStep
{
  loadingInit: boolean;
  loadingDuration: boolean;
  loading: boolean;
  isInit: boolean;
  serviceId: number;
  form: FormGroup;
  physicianDefault: PhysicianFilter;
  @Input("showAppointmeDate") showAppointmeDate: boolean = false;

  filterCompleteEquipments: FilterCompleteService<EquipmentFilter>;
  filterCompletePhysicians: FilterCompleteService<PhysicianFilter>;

  constructor(
    private equipmentService: EquipmentService,
    private filterService: FilterService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private notificationToastService: NotificationToastService,
    public reservationWizardService: ReservationWizardService
  ) {
    this.form = this.formBuilder.group({
      Equipment: ["", [Validators.required, ValidateAutoCompleteSelect]],
      Physician: ["", [Validators.required, ValidateAutoCompleteSelect]],
      AppointmentDate: [null],
      Duration: [{ value: "", disabled: true }, [Validators.required]],
    });

    this.filterCompleteEquipments = new FilterCompleteService<EquipmentFilter>(
      [],
      this.form.controls.Equipment
    );
    this.filterCompletePhysicians = new FilterCompleteService<PhysicianFilter>(
      [],
      this.form.controls.Physician
    );

    this.form.valueChanges.subscribe(() => {
      this.reservationWizardService.setReservationExtraordinaryCalendar(
        <ReservationExtraordinaryCalendar>this.form.getRawValue()
      );
    });
  }

  get filteredEquipmentsOptions() {
    return this.filterCompleteEquipments
      ? this.filterCompleteEquipments.filteredOptions
      : [];
  }

  get filteredPhysiciansOptions() {
    return this.filterCompletePhysicians
      ? this.filterCompletePhysicians.filteredOptions
      : [];
  }

  get f() {
    return this.form.controls;
  }

  get completed(): boolean {
    return this.isValid();
  }

  isValid() {
    return this.form && this.form.valid;
  }

  get valid(): boolean {
    return this.completed;
  }

  ngOnInit(): void {
    this.isInit = true;
    if (this.showAppointmeDate) {
      this.form.controls.AppointmentDate.setValidators([Validators.required]);
    }
  }

  async finalize() {
    if (this.isValid()) {
      this.loading = true;
      try {
        await this.reservationWizardService.finalizeReservation();
      } catch (err) {
        console.log(err);
        this.notificationToastService.error(
          JSON.stringify(err),
          "Reserva extraordinaria"
        );
      } finally {
        this.loading = false;
      }
    }
  }

  async activate() {
    try {
      const reservations =
        this.reservationWizardService.reservation.ServiceReservations.length >
        0;
      let actual = this.reservationWizardService.getServiceReservation(0);

      let actualServiceId = actual ? actual.serviceId() : 0;

      let index = 1;
      while (reservations && (!actual || actual.serviceId() == 0)) {
        actual = this.reservationWizardService.getServiceReservation(index);
        actualServiceId = actual.serviceId();
        index++;
      }

      if (this.serviceId !== actualServiceId) {
        this.loading = true;
        this.serviceId = actualServiceId;

        const equipmentResponse =
          await this.equipmentService.getEquipmentFiltersByExtraordinary(
            actualServiceId,
            this.authService.getSectorId()
          );

        const physicians = await this.filterService.getPhysiciansFilter(
          this.reservationWizardService.allPracticesIds
        );

        this.filterCompleteEquipments =
          new FilterCompleteService<EquipmentFilter>(
            equipmentResponse.Equipments,
            this.form.controls.Equipment
          );

        this.filterCompletePhysicians =
          new FilterCompleteService<PhysicianFilter>(
            physicians,
            this.form.controls.Physician
          );

        this.physicianDefault = physicians.find(
          (p) => p.Id === equipmentResponse.PhysicianId
        );
      }
    } catch (err) {
      console.log(err);
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Reserva extraordinaria"
      );
    } finally {
      this.loading = false;
    }
  }

  onEquipmentChange(searchValue: string): void {
    this.form.patchValue({ Physician: "" });
    this.form.patchValue({ Duration: "" });
  }

  async equipmentSelected(equipment: EquipmentFilter) {
    this.form.patchValue({ Duration: "" });
    this.form.patchValue({
      Physician: this.physicianDefault,
    });

    if (this.physicianDefault) {
      await this.physicianSelected(this.physicianDefault);
    }
  }

  onPhysicianChange(searchValue: string): void {
    this.form.patchValue({ Duration: "" });
  }

  async physicianSelected(physician: PhysicianFilter) {
    try {
      const equipment = this.form.controls.Equipment.value;
      if (physician && equipment) {
        this.loadingDuration = true;
        const duration =
          await this.reservationWizardService.durationExtraordinaryReservation(
            equipment.Id,
            physician.Id
          );
        this.form.patchValue({ Duration: duration });
      } else {
        this.form.patchValue({ Duration: "" });
      }
    } catch (err) {
      console.log(err);
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Reserva extraordinaria"
      );
    } finally {
      this.loadingDuration = false;
    }
  }

  save(): void {}
}
